var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIndeterminate = function SvgIndeterminate(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 13a.97.97 0 0 1-.713-.287A.97.97 0 0 1 6 12q0-.424.287-.713A.97.97 0 0 1 7 11h10q.424 0 .712.287.288.288.288.713 0 .424-.288.713A.97.97 0 0 1 17 13z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIndeterminate);
export { ForwardRef as ReactComponent };